import { render, staticRenderFns } from "./addAlipay.vue?vue&type=template&id=58d74fc2&scoped=true"
import script from "./addAlipay.vue?vue&type=script&lang=js"
export * from "./addAlipay.vue?vue&type=script&lang=js"
import style0 from "./addAlipay.vue?vue&type=style&index=0&id=58d74fc2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d74fc2",
  null
  
)

export default component.exports